import { render, staticRenderFns } from "./RoundView.vue?vue&type=template&id=968ede84&scoped=true"
import script from "./RoundView.vue?vue&type=script&lang=js"
export * from "./RoundView.vue?vue&type=script&lang=js"
import style0 from "./RoundView.vue?vue&type=style&index=0&id=968ede84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968ede84",
  null
  
)

export default component.exports